export const basicFields = `
  numberOfEmployees
`
